import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/(common-header-footer)/content-wrapper/content-wrapper-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/(common-header-footer)/sidebar-controlled-width-wrapper/sidebar-controlled-width-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TagsPageDataProvider"] */ "/app/app/[lang]/(common-header-footer)/tags/(tag-page)/[tagName]/[tagId]/get-tag-page-analytics/tag-page-analytics-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/intro/ad-slot/sticky-footer-ad/sticky-footer-visiblity-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserGamePreferenceProviderClient"] */ "/app/app/components/fav-page/preference-provider/preference-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/footer/footer-links/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/footer/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FullScreenProvider"] */ "/app/app/components/gameplayer-page/actions-section/buttons/full-screen/full-screen-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/header/desktop-header/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/header/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/continue-playing/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/game-cards/horizontal/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/header/sections/desktop/search/search-bar/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/header/sections/desktop/search/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/load-on-interaction/interaction-placeholder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadOnUserInteractionClient"] */ "/app/app/components/load-on-interaction/load-on-interaction-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/search-section/featured-games/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/featured-games/glowing-number/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/tag-section-head/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/search-section/search-result-card/search-card-image/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/search-section/search-result-card/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/search-section/search-bar/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/search-section/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/desktop-sidebar/wide-monitor-sidebar/head-text/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/other-products/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/desktop-sidebar/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/ads/display-ad/rsc/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/[lang]/intro/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/[lang]/intro/ad-slot/sticky-footer-ad/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/intro/logo/logo-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/footer/footer-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/footer/footer-links/do-not-sell-personal-info/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/footer/footer-links/footer-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/footer/language-switch/translate-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/game-cards/vertical/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/header/analytics/visiblity-analytics-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/mobile-headers/header-wrapper/header-wrapper-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/sections/a2hs-button/a2hs-button-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/sections/desktop/a2hs-button/a2hs-button-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sidebar/sidebar-draggable-wrapper/sidebar-draggable-wrapper-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/app/app/components/sidebar/sidebar-visiblity-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/sliders/featured-games-slider/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/search-section/search-results/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/sliders/continue-playing-slider/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/header/sections/desktop/a2hs-button/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/sections/desktop/search/backdrop/search-backdrop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/sections/desktop/search/focus-visiblity-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/sections/desktop/search/search-bar/search-bar-desktop-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/header/sections/hamburger-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/sections/logo/logo-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/header/sections/search-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/home-page-sections/analytics/analytics-wrapper-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/tag-section-head/view-all-btn/view-all-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/route-navigation-spinner/route-navigation-spinner.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/search-section/no-search-visiblity/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/search-section/search-bar/search-bar-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/search-section/search-result-card/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/search-section/search-results/search-results-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sidebar/desktop-sidebar/sidebar-visiblity-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sidebar/desktop-sidebar/wide-monitor-sidebar/other-products/product.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/desktop-sidebar/wide-monitor-sidebar/other-products/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sidebar/desktop-sidebar/wide-monitor-sidebar/tags-container/desktop-wide-sidebar-tag/desktop-wide-sidebar-tag-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sidebar/other-products/product.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/sidebar-tag/fav-sidebar-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sidebar/sidebar-tag/sidebar-game-tag-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/sidebar-tags-container/animate-visiblity/animate-visiblity-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/sidebar-tags-container/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sliders/continue-playing-slider/continue-playing-slider-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderAnalyticsProvider"] */ "/app/app/components/sliders/slider/analytics-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sliders/slider/slider-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/ad-collapser/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/ad-not-found/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/display-ad.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentScript"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/script/consent-script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
